import request from '../utils/request';

export default {
  querykhzh(params) {
    return request.get('/zwtjcx/khzhcx', params);
  },
  queryzhmx(params) {
    return request.get('/zwtjcx/zhmxcx', params);
  },
};



// WEBPACK FOOTER //
// ./src/api/zwtjcx.api.js